import { ProductInformation } from "shared/types/__generated__/graphql"

import {
  VariantKeyDisplay,
  VariantKeyDisplayProps as VariantKeyDisplayBaseProps
} from "entities/products/ui/variant-key-display/VariantKeyDisplay"

import { useProductPageAddonTitlesContext } from "../context/ProductPageAddonTitlesContext"

interface ProductPageVariantKeyDisplayProps
  extends Omit<VariantKeyDisplayBaseProps, "titleByProductType"> {
  addons?:
    | Pick<ProductInformation, "title" | "variantKey" | "productType">[]
    | null
}

export function ProductPageVariantKeyDisplay(
  props: ProductPageVariantKeyDisplayProps
) {
  const { titleByProductType } = useProductPageAddonTitlesContext()
  return (
    <VariantKeyDisplay {...props} titleByProductType={titleByProductType} />
  )
}
